<template>
  <div>
    <!-- Cabeçalho -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Prospecções</h5>
      <b-button
        v-if="hasPermission('adicionar_prospeccao')"
        variant="primary"
        class="d-flex align-items-center"
        @click="irParaCadastro"
      >
        <i class="bi bi-plus-circle-fill mr-2" title="Nova Prospecção"></i>
      </b-button>
    </div>

    <!-- Filtros -->
    <div class="d-flex mb-3" style="gap: 10px;">
      <select
        v-model="filters.quando"
        @change="pesquisarProspeccoes"
        class="form-select same-height-select"
        style="width: 13%;"
      >
        <option value="Hoje">Hoje</option>
        <option value="Pendentes">Pendentes</option>
        <option value="Futuros">Futuros</option>
        <option value="Finalizados">Finalizados</option>
        <option value="Contratados">Contratados</option>
        <option value="Todos">Todos</option>
      </select>

      <input
        v-model="filters.contato"
        @input="pesquisarProspeccoes"
        type="text"
        placeholder="Filtrar por Contato"
        class="form-control same-height-select"
        style="width: 23%;"
      />

      <input
        v-model="filters.aluno"
        @input="pesquisarProspeccoes"
        type="text"
        placeholder="Filtrar por Aluno"
        class="form-control same-height-select"
        style="width: 23%;"
      />

      <select
        v-model="filters.classificacao"
        @change="pesquisarProspeccoes"
        class="form-select same-height-select"
        style="width: 18%;"
      >
        <option value="">Selecione Classificação</option>
        <option value="Prospect">Prospect</option>
        <option value="Prospect - Agendar Aula Experimental">
          Prospect - Agendar Aula Experimental
        </option>
        <option value="Aula experimental - confirmar">
          Aula experimental - confirmar
        </option>
        <option value="Aula experimental - confirmada">
          Aula experimental - confirmada
        </option>
      </select>

      <select
        v-model="filters.acao"
        @change="pesquisarProspeccoes"
        class="form-select same-height-select"
        style="width: 15%;"
        :disabled="!filters.classificacao"
      >
        <option value="">Selecione Ação</option>
        <option v-for="item in acoesOptions" :key="item" :value="item">
          {{ item }}
        </option>
      </select>

      <b-button variant="secondary" @click="limparFiltros" class="d-flex align-items-center justify-content-center">
        <i class="bi bi-funnel mr-2" title="Limpar Filtro"></i>
      </b-button>
    </div>

    <!-- Tabela -->
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>
            <button class="btn btn-link p-0" @click="sort('id')">
              # {{ arrow('id') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('nome')">
              Contato {{ arrow('nome') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('aluno')">
              Aluno {{ arrow('aluno') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('classificacao')">
              Classificação {{ arrow('classificacao') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('acao')">
              Última ação {{ arrow('acao') }}
            </button>
          </th>
          <th>
            <button class="btn btn-link p-0" @click="sort('data_proximo_contato')">
              Agendamento {{ arrow('data_proximo_contato') }}
            </button>
          </th>
          <th class="text-end">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in prospeccoes" :key="item.id">
          <td>{{ item.id }}</td>
          <td>{{ item.nome }}</td>
          <td>{{ item.nome_aluno }}</td>
          <td>{{ item.classificacao }}</td>
          <td>{{ item.acao }}</td>
          <td>{{ globalUtils.formatarData(item.data_proximo_contato) }}</td>
          <td class="text-end">
            <router-link
              v-if="hasPermission('detalhar_prospeccao')"
              :to="`/operacional/prospeccao/${item.id}/detalhar`"
            >
              <i class="bi bi-eye-fill text-primary me-2" title="Detalhar"></i>
            </router-link>
            <router-link
              v-if="hasPermission('alterar_prospeccao')"
              :to="`/operacional/prospeccao/${item.id}`"
            >
              <i class="bi bi-pencil-fill text-warning me-2" title="Editar"></i>
            </router-link>
            <i
              v-if="hasPermission('excluir_prospeccao')"
              class="bi bi-trash-fill text-danger me-2"
              @click="excluirProspeccao(item.id)"
              title="Excluir"
            ></i>
          </td>
        </tr>
      </tbody>
    </table>

      <!-- Paginação -->
      <div class="d-flex justify-content-between align-items mt-3">
        <!-- resumo -->
        <div>
          Mostrando {{ startRow }} a {{ endRow }} de {{ totalRegistros }} registros
        </div>

        <div class="d-flex align-items" style="gap: .5rem;">
                  <b-form-select
            v-model="limitePorPagina"
            :options="pageOptions.map(n => ({ value: n, text: n + ' / página' }))"
            size="sm"
            style="width: 6rem"
            @change="paginaAtual = 1; fetchList()"
          />
        </div>

        <!-- selectors + paginação -->
        <div class="d-flex align-items">
          <b-pagination
            v-model="paginaAtual"
            :per-page="limitePorPagina"
            :total-rows="totalRegistros"
            size="sm"
            limit="5"
            @input="fetchList"
          />
        </div>
      </div>
  </div>
</template>

<script>
import axios from '@/services/axios';
import { BButton, BPagination, BFormSelect } from 'bootstrap-vue-next';
import { usePermissions } from '@/composables/usePermissions';
import globalUtils from '@/utils/globalUtils.js';


export default {
  components: { BButton, BPagination, BFormSelect },
  data() {
    return {
      globalUtils,
      prospeccoes: [],
      fields: [],
      filters: {
        quando: 'Pendentes',
        contato: '',
        aluno: '',
        classificacao: '',
        acao: ''
      },
      paginaAtual: 1,
      limitePorPagina: 10,
      totalPaginas: 1,
      totalRegistros: 0,                // <-- novo
      pageOptions: [10, 15, 20, 25, 50], // <-- dropdown de limites
      sortField: 'data_proximo_contato',
      sortOrder: 'asc'
    };
  },
  computed: {
    acoesOptions() {
      const options = {
        Prospect: ['Contato Reagendado', 'Finalizado', 'Matrícula', 'Prospect'],
        'Prospect - Agendar Aula Experimental': [
          'Aula Experimental Agendada',
          'Contato Reagendado',
          'Finalizado',
          'Matrícula'
        ],
        'Aula experimental - confirmar': [
          'Aula Experimental Cancelada',
          'Aula Experimental Confirmada',
          'Aula Experimental Reagendada',
          'Contato Reagendado',
          'Finalizado',
          'Matrícula'
        ],
        'Aula experimental - confirmada': [
          'Aula Experimental Reagendada',
          'Aula Experimental Cancelada',
          'Contato Reagendado',
          'Finalizado',
          'Matrícula',
          'Ausente',
          'Presente'
        ]
      }; return options[this.filters.classificacao] || [];
    },

    startRow() {
        return (this.paginaAtual - 1) * this.limitePorPagina + 1
    },
    endRow() {
        return Math.min(this.paginaAtual * this.limitePorPagina, this.totalRegistros)
    }
  },

  watch: {
    paginaAtual() {
      this.fetchList();   // dispara ao mudar de página
    }
  },

  methods: {
    async fetchList() {
      const params = {
        page: this.paginaAtual,
        limit: this.limitePorPagina,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        contato: this.filters.contato || undefined,
        aluno: this.filters.aluno || undefined,
        classificacao: this.filters.classificacao || undefined,
        acao: this.filters.acao || undefined,
        quando:
          this.filters.quando === 'Contratados'
            ? 'Contratados'
            : this.filters.quando
      };
      const res = await axios.get(
        `/operacional/prospeccao`,
        { params }
      );
      const { data, totalPages, totalRecords } = res.data
      this.prospeccoes = data.map((item, i) => ({
        ...item,
        seq: i + 1 + (this.paginaAtual - 1) * this.limitePorPagina
      }))
      this.totalPaginas   = totalPages
      this.totalRegistros = totalRecords     // <-- use aqui o total vindo da API
    },
    sort(col) {
      if (this.sortField === col) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = col;
        this.sortOrder = 'asc';
      }
      this.fetchList();
    },
    arrow(col) {
      if (this.sortField !== col) return '';
      return this.sortOrder === 'asc' ? '▲' : '▼';
    },
    pesquisarProspeccoes() {
      this.paginaAtual = 1;
      this.fetchList();
    },
    limparFiltros() {
      this.filters = {
        quando: 'Hoje',
        contato: '',
        aluno: '',
        classificacao: '',
        acao: ''
      };
      this.paginaAtual = 1;
      this.fetchList();
    },
    alterarLimite() {
      this.paginaAtual = 1;
      this.fetchList();
    },
    paginaAnterior() {
      if (this.paginaAtual > 1) {
        this.paginaAtual--;
        this.fetchList();
      }
    },
    proximaPagina() {
      if (this.paginaAtual < this.totalPaginas) {
        this.paginaAtual++;
        this.fetchList();
      }
    },
    irParaCadastro() {
      this.$router.push('/operacional/prospeccao/novo');
    },
    async excluirProspeccao(id) {
      const confirmou = await this.$confirm(
        'Tem certeza que deseja excluir esta prospecção?',
        'Confirmação'
      );
      if (confirmou) {
        try {
          const response = await axios.delete(
            `/operacional/prospeccao/${id}`,
            {
              validateStatus: status => status >= 200 && status < 300
            }
          );
          if (response.data.blocked) {
            await this.$alert(response.data.message, 'Atenção');
            return;
          }
          this.fetchList();
          this.$toast.success('Prospecção excluída com sucesso!');
        } catch (error) {
          console.error('Erro ao excluir prospecção:', error);
          let mensagem = 'Erro inesperado ao excluir a prospecção.';
          if (error.response && error.response.data) {
            mensagem = error.response.data.error || mensagem;
          }
          await this.$alert(mensagem, 'Não permitido');
        }
      }
    }
  },
  async mounted() {
    const { fetchPermissions, hasPermission } = usePermissions();
    this.hasPermission = hasPermission;
    await fetchPermissions();

    const featureFlags = this.$globalState?.featureFlags || {};
    const prospeccaoFeature = featureFlags?.PROSPECCAO;

    if (this.$globalState?.featuresLoaded && prospeccaoFeature && prospeccaoFeature.enabled === false) {
      if (typeof this.$alert === 'function') {
        await this.$alert(
          prospeccaoFeature.message || 'Módulo exclusivo para o Plano Performance',
          'Plano'
        );
      } else {
        alert(prospeccaoFeature.message || 'Módulo exclusivo para o Plano Performance');
      }

      this.$router.push('/dashboard');
      return;
    }

    this.fetchList();
  }
};
</script>

<style scoped>
.same-height {
  height: 30px;
  padding: 6px 12px;
  font-size: 0.72rem;
}
.same-height-select {
  height: 30px;
  padding: 6px 2.25rem 6px 0.75rem;
  border-radius: 0 !important;
}

:deep(.pagination.pagination-sm .page-link) {
  padding: rem rem;
  line-height: 1;
  font-size: 0.8rem !important;
  border-radius: 0 !important;
}

</style>